<template>
  <div>
    <reviews
        :posts="posts"
        :is-section-show="isSectionShow"
        :is-category-show="isCategoryShow"
        :is-author-show="isAuthorShow"
    />
    <a
        href="#"
        class="btn btn-light btn-block"
        v-if="!loading"
        @click.prevent="fetchReviews"
    >
      Xem thêm
    </a>
    <div class="page-load-status" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import axios from 'axios';
import Reviews from './Reviews.vue';

const props = defineProps({
  sectionId: {
    type: [String, Number],
    required: true
  },
  page: {
    type: Number,
    default: 1
  }
});

const root = inject('root');

const posts = ref([]);
const errors = ref([]);
const pageNumber = ref(props.page);
const loading = ref(false);
const isSectionShow = ref(false);
const isCategoryShow = ref(true);
const isAuthorShow = ref(true);

const fetchReviews = async (event) => {
  if (event && event.preventDefault) event.preventDefault();
  loading.value = true;
  pageNumber.value++;
  const baseUri = process.env.MOVEEK_API_ENDPOINT;
  try {
    const response = await axios.get(
        `${baseUri}/v1/posts?section.id=${props.sectionId}&page=${pageNumber.value}&published_before]=${encodeURIComponent(root.moment().toISOString(true))}`
    );
    posts.value.push(...response.data);
  } catch (error) {
    errors.value.push(error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchReviews();
});
</script>

<style scoped>
.page-load-status {
  display: block;
}
</style>
